import { render } from "./vueForm.vue?vue&type=template&id=1b2066d3&scoped=true&ts=true"
import script from "./vueForm.vue?vue&type=script&lang=ts"
export * from "./vueForm.vue?vue&type=script&lang=ts"

import "./vueForm.vue?vue&type=style&index=0&id=1b2066d3&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2066d3"]])

export default __exports__